import { Trans } from 'next-i18next';
import React, { ComponentPropsWithRef, FC } from 'react';
import { Text } from '@components/Text/Text.component';
import { CircleChevronDownIcon } from '@icons/CircleChevronDown.icon';
import { PlcAccordion } from '@layout/components/PlcAccordion/PlcAccordion.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { PlcColor } from '@styles/colors';
import classnames from 'classnames';
import styles from './FAQs.module.scss';

type Props = ComponentPropsWithRef<'section'>;

const list = [
  {
    answer: 'landing-app.faqs.answer-1',
    question: 'landing-app.faqs.question-1',
  },
  {
    answer: 'landing-app.faqs.answer-2',
    question: 'landing-app.faqs.question-2',
  },
  {
    answer: 'landing-app.faqs.answer-3',
    question: 'landing-app.faqs.question-3',
  },
  {
    answer: 'landing-app.faqs.answer-4',
    question: 'landing-app.faqs.question-4',
  },
  {
    answer: 'landing-app.faqs.answer-5',
    question: 'landing-app.faqs.question-5',
  },
  {
    answer: 'landing-app.faqs.answer-6',
    question: 'landing-app.faqs.question-6',
  },
];

const FAQs: FC<Props> = ({ className }) => {
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const rootClass = classnames(className, styles.faqs);

  return (
    <section className={rootClass}>
      <Text i18nKey="landing-app.faqs.title" tag="h3" variant={isMobile ? 'new-h3' : 'h3'} />
      <Text i18nKey="landing-app.faqs.desc" tag="p" variant="p" />
      {list.map((elem) => {
        const { question, answer } = elem;
        return (
          <PlcAccordion
            className={styles.accordion}
            expandIcon={
              <CircleChevronDownIcon fill={PlcColor.GREY} fillColor={PlcColor.GREEN} height={20} width={20} />
            }
            key="landing-page-app-acc"
            titleComponent={<Text i18nKey={question} variant={isMobile ? 'h5' : 'h4'} />}
          >
            <Text variant="p">
              <Trans i18nKey={answer} ns="landing-app" />
            </Text>
          </PlcAccordion>
        );
      })}
    </section>
  );
};

export { FAQs };
